<h2 mat-dialog-title>
  Estoque por Local: <strong>{{ data.nomeVariavel }}</strong>
</h2>

<mat-dialog-content>
  <form [formGroup]="form">
    @if (temPendencia) {
      <app-alert-card type="warning">
        Informe {{ tipoRastreio === 'serie' ? 'as séries' : 'os lotes' }} de cada local até bater com o estoque atual para confirmar.
      </app-alert-card>
    }

    <div class="d-flex justify-content-end mb-3">
      <button mat-button type="button" (click)="addEstoqueRow()">
        <mat-icon>add</mat-icon> Adicionar Local
      </button>
    </div>

    <div formArrayName="estoque">
      @for (item of estoqueArray.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="margin-bottom-50">
          <div class="row">
            <div class="col-10 col-md-11">
              <div class="row">
                <!-- Local de Estoque -->
                <div class="col-6 col-lg-4">
                  <app-select-pesquisavel
                    [offlineList]="localizacoesDisponiveis($any(item))"
                    [control]="$any(item).get('idLocalizacaoEstoque')"
                    idField="idLocalizacaoEstoque"
                    nameField="nome"
                    label="Local de Estoque"
                    [disabled]="isLocalPadrao($any(item).get('idLocalizacaoEstoque').value)"
                    placeholder="Selecione o local...">
                  </app-select-pesquisavel>
                </div>
                <!-- Saldo Atual (editável só na inclusão) -->
                @if (!data.isEditMode) {
                  <div class="col-6 col-lg-2">
                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 no-bottom-space">
                      <mat-label>Atual</mat-label>
                      <input matInput formControlName="saldoFisico" [currencyMask]="data.quantidadeMask" />
                    </mat-form-field>
                  </div>
                } @else {
                  <div class="col-3 col-lg-1 info-flex">
                    <small>Atual</small>
                    <strong>{{ item.get('saldoFisico')?.value ?? '—' }}</strong>
                  </div>
                  <div class="col-3 col-lg-1 info-flex">
                    <small>Disponível</small>
                    <strong>{{ item.get('saldoDisponivel')?.value ?? '—' }}</strong>
                  </div>
                }
                <!-- Mínimo -->
                <div class="col-6 col-lg-3">
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100 no-bottom-space">
                    <mat-label>Mínimo</mat-label>
                    <input matInput formControlName="estoqueMinimo" [currencyMask]="data.quantidadeMask" />
                  </mat-form-field>
                </div>
                <!-- Máximo -->
                <div class="col-6 col-lg-3">
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                    class="w-100 no-bottom-space">
                    <mat-label>Máximo</mat-label>
                    <input matInput formControlName="estoqueMaximo" [currencyMask]="data.quantidadeMask" />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <!-- Delete -->
            <div class="col-2 col-md-1 produto-grid-delete-col">
              @if (!isLocalPadrao($any(item).get('idLocalizacaoEstoque').value)) {
                <button
                  mat-icon-button
                  class="delete-button"
                  type="button"
                  (click)="removeEstoqueRow(i)"
                  matTooltip="Remover">
                  <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
              }
            </div>
          </div>

          <!-- Painel inline de lote/série (balanço inicial da variação) -->
          @if (mostrarPainelRastreio(item)) {
            <app-estoque-lote-serie-inline
              [tipo]="tipoRastreio!"
              [quantidadeAlvo]="item.get('saldoFisico')?.value || 0"
              [isFracionada]="data.isFracionada ?? true"
              [contexto]="nomeLocal(item)"
              [itens]="itensRastreio(item)"
              [codigosSerieEmOutrosLocais]="codigosSerieEmOutrosLocais(item)"
              (itensChange)="onItensRastreioChange(item, $event)"
              (completoChange)="onCompletoChange(item, $event)">
            </app-estoque-lote-serie-inline>
          }
        </div>
      }
    </div>

    @if (estoqueArray.length === 0) {
      <app-empty-state icon="inventory_2" title="Nenhum local de estoque definido para esta variação."
        subtitle="Adicione um local para informar o saldo inicial desta combinação.">
      </app-empty-state>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button mat-flat-button class="btn-primary" [disabled]="temPendencia" (click)="confirmar()">Confirmar e Salvar</button>
</mat-dialog-actions>
